import { ColumnProvider } from '../interfaces/ColumnProvider';
import { ColumnWidthRatio } from '../interfaces/ColumnWidthRatio';
import { getColumnRange } from './getColumnRange';
import { getColumnRangeHorizontalLayout } from './getColumnRangeHorizontalLayout';
import { LayoutInterval } from '../interfaces/LayoutInterval';

/**
 * Gets the horizontal layout of the given layout interval.
 * @param interval A layout interval.
 * @param columnCount The count of columns in the current view.
 * @param columnLength The length of the columns in the current view.
 * @param isRTL A value indicating whether the UI is rendering right-to-left.
 * @returns The relative distance (in %) the layout interval has from the left and right borders of the view.
 */
export function getHorizontalLayout(
    interval: LayoutInterval,
    columnProvider: ColumnProvider,
    columnLength: number,
    isRTL: boolean
): ColumnWidthRatio {
    const { start, end } = getColumnRange(interval, columnProvider.columnCount, columnLength);
    return getColumnRangeHorizontalLayout(start, end, columnProvider, isRTL);
}
